import { ButtonProps, SxProps, Theme } from '@mui/material';

type ActionPropType = Omit<ButtonProps, 'variant'> & {
  label: string;
  variant?: 'primary' | 'warning' | 'destructive';
  loading?: boolean;
};

export type ModalButtonType = {
  label: string;
  onClick: (e?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  disabled?: boolean;
  type?: 'submit' | 'button' | 'reset';
  loading?: boolean;
  color?:
    | 'inherit'
    | 'primary'
    | 'secondary'
    | 'success'
    | 'error'
    | 'info'
    | 'warning';
  variant?: 'text' | 'outlined' | 'contained';
  tone?: 'primary' | 'warning' | 'destructive';
  sx?: SxProps<Theme>;
};

export const convertToActionProp = (
  button?: ModalButtonType,
): ActionPropType | undefined => {
  if (!button) return undefined;

  return {
    ...button,
    variant: button.tone,
  };
};
